import { fillArr } from '@hglobal/fin-ui';

import { Operation, OperationStatus } from '@iw/core/entities';
import { getCurrenciesMock } from '@iw/store';

import { GetOrderRes, Order } from '../models/get-order-res.model';

export function getOrdersHistoryListMock(count = 10): Operation[] {
  const statuses = Object.values(OperationStatus);
  return fillArr(count, (i) => ({
    id: i.toString(),
    createdAt: new Date(Date.now() - i * 1000 * 60 * 60).toJSON(),
    updatedAt: new Date(Date.now() - i * 1000 * 60 * 60).toJSON(),
    type: 'Withdrawal',
    status: statuses[i % statuses.length],
    amount: ((i + 1) * 100).toString(),
    commission: '1.00',
    comment: 'Txn ID/RRN: 013486661288\nResp.Code: 000 (Approved)',
    fromAccountId: i % 2 === 0 ? 'account1' : 'account2',
    toAccountId: i % 2 === 0 ? 'account2' : 'account1',
    details: {
      from: i % 2 === 0 ? 'USD' : 'EUR',
      to: i % 2 === 0 ? 'EUR' : 'USD',
      fromName: 'US Dollar',
      toName: 'Euro',
      rate: '0.97',
      convertedAmount: '970',
      currency: 'EUR',
      currencyName: 'Euro',
    },
  }));
}

export function getOrderInfoMock(): Order {
  return {
    id: 'order-1',
    currency: getCurrenciesMock()[0],
    method: 'method1',
    accountId: 'account1',
    amount: (2 * 100).toString(),
    createdAt: new Date(Date.now() - 1000 * 60 * 60).toJSON(),
    updatedAt: new Date(Date.now() - 1000 * 60 * 60).toJSON(),
  };
}

export function getOrderDetailsMock(): GetOrderRes {
  const item = getOrdersHistoryListMock(1)[0];
  const commentsCount = 100;
  const commentsStartDate = new Date(
    Date.now() - 1000 * 60 * 60 * commentsCount,
  );
  return {
    item,
    order: getOrderInfoMock(),
    comments: fillArr(100, (i) => ({
      id: i.toString(),
      message: 'message' + ' test string'.repeat(i % 10),
      userId: i % 8 < 4 ? null : 'user',
      createdAt: new Date(
        commentsStartDate.getTime() + i * 1000 * 60 * 60,
      ).toJSON(),
    })),
  };
}
